<template>
  <b-col class="p-0">
    <b-row>
      <b-col>Points</b-col>
      <b-col>Deduction</b-col>
      <b-col>Total</b-col>
      <b-col>Round</b-col>
      <b-col>Total</b-col>
      <b-col>Deduction</b-col>
      <b-col>Points</b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-select class="native text-center" :options="select" plain v-model="r1Red"/>
      </b-col>
      <b-col>
        <b-select class="native text-center" :options="deduction" plain v-model="r1RedDeduction"/>
      </b-col>
      <b-col>
        <b-form-input class="text-center" :value="r1RedTotal()" disabled/>
      </b-col>
      <b-col>
        <b-form-input class="text-center" disabled value="1"/>
      </b-col>
      <b-col>
        <b-form-input class="text-center" :value="r1BlueTotal()" disabled/>
      </b-col>
      <b-col>
        <b-select class="native text-center" :options="deduction" plain v-model="r1BlueDeduction"/>
      </b-col>
      <b-col>
        <b-select class="native text-center" :options="select" plain v-model="r1Blue"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-select class="native text-center" :options="select" plain v-model="r2Red"/>
      </b-col>
      <b-col>
        <b-select class="native text-center" :options="deduction" plain v-model="r2RedDeduction"/>
      </b-col>
      <b-col>
        <b-form-input class="text-center" :value="r2RedTotal()" disabled/>
      </b-col>
      <b-col>
        <b-form-input class="text-center" disabled value="2"/>
      </b-col>
      <b-col>
        <b-form-input class="text-center" :value="r2BlueTotal()" disabled/>
      </b-col>
      <b-col>
        <b-select class="native text-center" :options="deduction" plain v-model="r2BlueDeduction"/>
      </b-col>
      <b-col>
        <b-select class="native text-center" :options="select" plain v-model="r2Blue"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-select class="native text-center" :options="select" plain v-model="r3Red"/>
      </b-col>
      <b-col>
        <b-select class="native text-center" :options="deduction" plain v-model="r3RedDeduction"/>
      </b-col>
      <b-col>
        <b-form-input class="text-center" :value="r3RedTotal()" disabled/>
      </b-col>
      <b-col>
        <b-form-input class="text-center" disabled value="3"/>
      </b-col>
      <b-col>
        <b-form-input class="text-center" :value="r3BlueTotal()" disabled/>
      </b-col>
      <b-col>
        <b-select class="native text-center" :options="deduction" plain v-model="r3BlueDeduction"/>
      </b-col>
      <b-col>
        <b-select class="native text-center" :options="select" plain v-model="r3Blue"/>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col/>
      <b-col/>
      <b-col>
        <b-form-input class="font-weight-bold text-center" :value="r3RedTotal()" disabled/>
      </b-col>
      <b-col/>
      <b-col>
        <b-form-input class="font-weight-bold text-center" :value="r3BlueTotal()" disabled/>
      </b-col>
      <b-col/>
      <b-col/>
    </b-row>

  </b-col>
</template>

<script>
export default {
  name: 'Scorecard',
  props: ['judge'],
  data() {
    return {
      r1Red: '',
      r2Red: '',
      r3Red: '',
      r1RedDeduction: '',
      r2RedDeduction: '',
      r3RedDeduction: '',
      r1Blue: '',
      r2Blue: '',
      r3Blue: '',
      r1BlueDeduction: '',
      r2BlueDeduction: '',
      r3BlueDeduction: '',
      select: [{
        value: null,
        text: '',
      }, 10, 9, 8, 7],
      deduction: [{
        value: null,
        text: '',
      }, 0, -1, -2, -3],
    };
  },
  methods: {
    r1RedTotal() {
      let sum = 0;
      if (this.r1Red) sum += parseInt(this.r1Red, 10);
      if (this.r1RedDeduction) sum += parseInt(this.r1RedDeduction, 10);
      return sum;
    },
    r2RedTotal() {
      let sum = this.r1RedTotal();
      if (this.r2Red) sum += parseInt(this.r2Red, 10);
      if (this.r2RedDeduction) sum += parseInt(this.r2RedDeduction, 10);
      return sum;
    },
    r3RedTotal() {
      let sum = this.r2RedTotal();
      if (this.r3Red) sum += parseInt(this.r3Red, 10);
      if (this.r3RedDeduction) sum += parseInt(this.r3RedDeduction, 10);
      return sum;
    },
    r1BlueTotal() {
      let sum = 0;
      if (this.r1Blue) sum += parseInt(this.r1Blue, 10);
      if (this.r1BlueDeduction) sum += parseInt(this.r1BlueDeduction, 10);
      return sum;
    },
    r2BlueTotal() {
      let sum = this.r1BlueTotal();
      if (this.r2Blue) sum += parseInt(this.r2Blue, 10);
      if (this.r2BlueDeduction) sum += parseInt(this.r2BlueDeduction, 10);
      return sum;
    },
    r3BlueTotal() {
      let sum = this.r2BlueTotal();
      if (this.r3Blue) sum += parseInt(this.r3Blue, 10);
      if (this.r3BlueDeduction) sum += parseInt(this.r3BlueDeduction, 10);
      return sum;
    },
  },
};
</script>
<style>
  .native {
    appearance: none !important;
    -moz-appearance: none !important;
  }
</style>
